import { apiGet, systemRequestConfig } from '@api/api.utils'
import { IResponseBadgeCRM } from './api.types'

const route = '/common'

/** Получение информации по количеству данных, на которое стоит обратить внимание BADGE */
export const getCountInfoApp = (isSystemRequest: boolean = false): Promise<IResponseBadgeCRM> =>
    apiGet<IResponseBadgeCRM>(`${route}/getCountInfoApp`, isSystemRequest ? systemRequestConfig() : undefined)
